module.exports = __webpack_public_path__ + "assets/img/Ali1688.61b3e274.png";